export const SECTION_STATUS = {
  EDITABLE: 1,
  READONLY: 2,
  SECTION_PREVIEW: 3
}
